import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderOpen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"folder-open"} maskId="square-filled-radius-0-stroke-1-IconFolderOpen"><path fillRule="evenodd" clipRule="evenodd" d="M10.2676 3H2V20H20.1241L22.9185 10.5H21V6H12.2676L10.2676 3ZM20 10.5V7H11.7324L9.73241 4H3V19H5.12588L7.62588 10.5H20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFolderOpen;
